'use strict';

import {XMLIMPORT_UPLOAD_DATA} from '~/frontend/src/constants';

import {__} from '~/shared/src/utilities/messageCatalog';
import {
    UploadXmlImportParameters,
    UploadXmlImportResult
} from '~/shared/src/utilities/modules/xmlImport';

import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import xhr from '~/frontend/src/utilities/xhr';
import {
    MsgParams,
    setMessage
} from '~/frontend/src/actions/intercom';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string | string[]} data
 * @param {MsgParams | undefined} [successMsgParams=undefined]
 * @param {MsgParams | undefined} [nothingToSaveMsgParams=undefined]
 * @param {MsgParams | undefined} [errorMsgParams=undefined]
 *
 */
const uploadData = ( panelKey : string, data : string | string[], successMsgParams : MsgParams | undefined = undefined, nothingToSaveMsgParams : MsgParams | undefined = undefined, errorMsgParams : MsgParams | undefined = undefined ) : Thunk<Promise<UploadXmlImportResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<UploadXmlImportResult | false> => {
    dispatch( {
        type: XMLIMPORT_UPLOAD_DATA,
        panelKey,
        data,
        successMsgParams,
        nothingToSaveMsgParams,
        errorMsgParams
    } );

    const requestUid = 'uploadData';

    let retVal : UploadXmlImportResult | false = false;

    // nothing to upload
    if ( !data.length ) {
        if ( !nothingToSaveMsgParams ) {
            nothingToSaveMsgParams = [
                panelKey,
                'toast',
                'nothingToUpload',
                {
                    severity: 'info',
                    summary : __( 'YN.base.xmlImport.upload.nothingToUpload.title' ),
                    detail  : __( 'YN.base.xmlImport.upload.nothingToUpload.text' )
                }
            ];
        }

        dispatch( setMessage( ...nothingToSaveMsgParams ) );
    }

    // upload request running
    else if ( getState().xhr?.[ panelKey ]?.[ requestUid ] ) {
        dispatch( setMessage(
            panelKey,
            'toast',
            'uploadRunning',
            {
                severity: 'info',
                summary : __( 'YN.base.xmlImport.upload.running.title' ),
                detail  : __( 'YN.base.xmlImport.upload.running.text' )
            }
        ) );
    }

    // save
    else {
        /*dispatch( setMessage(
            panelKey,
            'toast',
            'upload',
            {
                severity: 'info',
                summary : __( 'YN.base.xmlImport.upload.uploading.title' ),
                detail  : __( 'YN.base.xmlImport.upload.uploading.text' )
            }
        ) );*/

        const params : UploadXmlImportParameters = {
                  xml: data
              },
              response                           = await xhr.post(
                  `${BASE_URL}/api/xmlimport/upload`,
                  params,
                  undefined,
                  panelKey,
                  requestUid,
                  dispatch
              );

        if ( response?.data ) {
            retVal = response.data as UploadXmlImportResult;

            // save success
            if ( retVal.success ) {

                if ( !successMsgParams ) {
                    successMsgParams = [
                        panelKey,
                        'toast',
                        'saveSuccess',
                        {
                            severity: 'success',
                            summary : __( 'YN.base.xmlImport.upload.success.title' ),
                            detail  : __( 'YN.base.xmlImport.upload.success.text' )
                        }
                    ];
                }

                dispatch( setMessage( ...successMsgParams ) );
            }

            // save error
            else if ( errorMsgParams ) {
                dispatch( setMessage( ...errorMsgParams ) );
            }
        }
    }

    return retVal;
}
export type UploadData = typeof uploadData;

export default uploadData;
